"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addManagedEventListener = void 0;
const addManagedEventListener = (emitter, eventName, listener, abortSignal) => {
    if (!abortSignal.aborted) {
        emitter.on(eventName, listener);
        abortSignal.addEventListener('abort', () => {
            emitter.off(eventName, listener);
        }, {
            once: true
        });
    }
};
exports.addManagedEventListener = addManagedEventListener;
//# sourceMappingURL=addManagedEventListener.js.map